// Api.js
const BASE_URL = "https://vartmannirnay.com:35443"; // Global API Base URL

export const registerUser = async (formData) => {
  try {
    const response = await fetch(`${BASE_URL}/register`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    const data = await response.text();
    return response.ok;
  } catch (error) {
    console.error("Registration error:", error);
    return false;
  }
};